import React from "react"
import { Table } from "antd"
import { COLORS, TYPE_LABELS, formatPoints } from "./format"

const categoryColumns = [
  { title: "Категория", dataIndex: "label" },
  { title: "Операция", dataIndex: "type", render: (type) => TYPE_LABELS[type] ?? type },
  { title: "Операций", dataIndex: "operations", align: "right" },
  { title: "Сумма", dataIndex: "points", align: "right", render: formatPoints },
]

// Период — строка; раскрывается разбивкой по категориям.
export function ReportTable({ rows = [], totals, isLoading }) {
  const columns = [
    { title: "Период", dataIndex: "date" },
    {
      title: "Начислено",
      dataIndex: "accrued",
      align: "right",
      render: (value) => <span style={{ color: COLORS.accrued }}>{formatPoints(value)}</span>,
    },
    {
      title: "Списано",
      dataIndex: "written_off",
      align: "right",
      render: (value) => <span style={{ color: COLORS.writtenOff }}>{formatPoints(value)}</span>,
    },
    { title: "Сгорело", dataIndex: "burned", align: "right", render: formatPoints },
    { title: "Итог", dataIndex: "net", align: "right", render: formatPoints },
    { title: "Операций", dataIndex: "operations", align: "right" },
  ]

  return (
    <Table
      size="small"
      rowKey="date"
      loading={isLoading}
      dataSource={rows}
      columns={columns}
      pagination={false}
      scroll={{ y: 520 }}
      expandable={{
        expandedRowRender: (row) => (
          <Table
            size="small"
            pagination={false}
            rowKey={(item) => `${item.category}-${item.type}`}
            dataSource={row.by_category}
            columns={categoryColumns}
          />
        ),
        rowExpandable: (row) => row.by_category?.length > 0,
      }}
      summary={() =>
        totals ? (
          <Table.Summary fixed>
            <Table.Summary.Row>
              <Table.Summary.Cell index={0} />
              <Table.Summary.Cell index={1}><b>Итого</b></Table.Summary.Cell>
              <Table.Summary.Cell index={2} align="right"><b>{formatPoints(totals.accrued)}</b></Table.Summary.Cell>
              <Table.Summary.Cell index={3} align="right"><b>{formatPoints(totals.written_off)}</b></Table.Summary.Cell>
              <Table.Summary.Cell index={4} align="right"><b>{formatPoints(totals.burned)}</b></Table.Summary.Cell>
              <Table.Summary.Cell index={5} align="right"><b>{formatPoints(totals.net)}</b></Table.Summary.Cell>
              <Table.Summary.Cell index={6} align="right"><b>{totals.operations}</b></Table.Summary.Cell>
            </Table.Summary.Row>
          </Table.Summary>
        ) : null
      }
    />
  )
}
